import React, { useState } from "react";
import { ChevronDown, ChevronRight, Info } from "lucide-react";

import { useAuth } from "@/lib/auth";
import { eintrag, istSeite } from "@/hilfe/register";

// Schicht 4 (Auftrag 8, R5): drei Sätze -- welche Frage die Seite beantwortet,
// was man hier tut, was nicht. Einklappbar; der Zustand gilt je Nutzer und
// Seite und liegt im localStorage. Kein Link auf eine Anleitung, die es noch
// nicht gibt.

export const seitenkopfSchluessel = (nutzerId, id) => `hilfe.seitenkopf.${nutzerId || "anonym"}.${id}`;

const zugeklapptLesen = (schluessel) => {
    try { return localStorage.getItem(schluessel) === "zu"; } catch { return false; }
};

const zugeklapptSchreiben = (schluessel, zu) => {
    try { zu ? localStorage.setItem(schluessel, "zu") : localStorage.removeItem(schluessel); }
    catch { /* Speicher gesperrt -- dann eben nur für diesen Besuch */ }
};

/** Die Ansicht ohne Anmeldung -- testbar ohne AuthProvider. */
export const SeitenkopfAnsicht = ({ id, nutzerId }) => {
    if (!istSeite(id)) throw new Error(`<Seitenkopf id="${id}">: Seitenköpfe haben ids "seite.<name>"`);
    const e = eintrag(id);
    const schluessel = seitenkopfSchluessel(nutzerId, id);
    const [zu, setZu] = useState(() => zugeklapptLesen(schluessel));
    if (!e) return null;
    const umschalten = () => { setZu(!zu); zugeklapptSchreiben(schluessel, !zu); };
    const Pfeil = zu ? ChevronRight : ChevronDown;
    return (
        <div className="max-w-2xl mt-1" data-testid={`seitenkopf-${id}`}>
            <button type="button" onClick={umschalten} aria-expanded={!zu}
                    className="inline-flex items-center gap-1 text-xs text-gray-500 hover:text-slate-900"
                    data-testid="seitenkopf-umschalten">
                <Pfeil size={12} /> <Info size={12} /> Wozu diese Seite
            </button>
            {!zu && (
                <dl className="mt-1.5 text-sm text-gray-600 space-y-1" data-testid="seitenkopf-text">
                    <div><dt className="inline font-medium text-slate-700">Frage: </dt><dd className="inline">{e.text.frage}</dd></div>
                    <div><dt className="inline font-medium text-slate-700">Hier tust du: </dt><dd className="inline">{e.text.tun}</dd></div>
                    <div><dt className="inline font-medium text-slate-700">Nicht hier: </dt><dd className="inline">{e.text.nicht}</dd></div>
                </dl>
            )}
        </div>
    );
};

export const Seitenkopf = ({ id }) => {
    const { nutzer } = useAuth();
    return <SeitenkopfAnsicht id={id} nutzerId={nutzer?.id} />;
};
